import React from "react";

const SectionPanel = ({ title, titleAddon, children }) => {
  return (
    <div className="analytics-section">
      <div className="section-panel">
        <div className="section-panel-header">
          <h5 className="section-panel-title">
            {title}
            {titleAddon}
          </h5>
        </div>
        <div className="section-panel-body">{children}</div>
      </div>
    </div>
  );
};

export default SectionPanel;
